module.exports = __webpack_public_path__ + "img/sliders.2bcca4ec.png";